import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import { GoogleLogin } from "@react-oauth/google"
import Back from "../common/Back"
import img from "../images/about.jpg"
import { useAuth } from "../../context/AuthContext"
import { authFetch } from "../../lib/api"
import "./auth.css"

const SignUp = () => {
  const history = useHistory()
  const { login } = useAuth()
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    if (password !== confirmPassword) {
      setError("Passwords do not match")
      return
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters")
      return
    }
    setLoading(true)
    try {
      const res = await authFetch("/api/auth/signup", {
        method: "POST",
        body: JSON.stringify({ name, email, password }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || "Sign up failed")
        return
      }
      login(data.token, data.user)
      history.push("/")
    } catch (err) {
      setError("Something went wrong. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  const handleGoogleSuccess = async (credentialResponse) => {
    const idToken = credentialResponse.credential
    if (!idToken) {
      setError("Google sign-up did not return a credential")
      return
    }
    setLoading(true)
    setError("")
    try {
      const res = await authFetch("/api/auth/google", {
        method: "POST",
        body: JSON.stringify({ idToken }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || "Google sign-up failed")
        return
      }
      login(data.token, data.user)
      history.push("/")
    } catch (err) {
      setError("Google sign-up failed")
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className='auth-section'>
      <Back name='Sign Up' title='Create your Vista Hill Houses account' cover={img} />
      <div className='auth-page'>
        <div className='container'>
          <div className='auth-card'>
            <h1 className='auth-card__title'>Create account</h1>
            <p className='auth-card__subtitle'>Get started with listings and saved properties</p>

            {error && <p className='auth-error'>{error}</p>}

            <div className='auth-google-wrap'>
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => setError("Google sign-up was cancelled or failed")}
                useOneTap={false}
                theme='outline'
                size='large'
                text='signup_with'
                shape='rectangular'
              />
            </div>

            <div className='auth-divider'>or continue with email</div>

            <form onSubmit={handleSubmit} className='auth-form'>
              <label htmlFor='signup-name'>Full name</label>
              <input
                id='signup-name'
                type='text'
                placeholder='Your name'
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <label htmlFor='signup-email'>Email</label>
              <input
                id='signup-email'
                type='email'
                placeholder='you@example.com'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <label htmlFor='signup-password'>Password</label>
              <input
                id='signup-password'
                type='password'
                placeholder='••••••••'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
              />
              <label htmlFor='signup-confirm'>Confirm password</label>
              <input
                id='signup-confirm'
                type='password'
                placeholder='••••••••'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
              />
              <button type='submit' className='auth-form__submit' disabled={loading}>
                {loading ? "Creating account…" : "Create account"}
              </button>
            </form>

            <div className='auth-footer'>
              Already have an account? <Link to='/signin'>Sign in</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SignUp
